import { useState } from "react";
import { deleteNoteURL } from "../utils/ConstantsURL";
import { toastAlert } from "../utils/AlertContext";

export const useDeleteNote = (token) => {
  const [loading, setLoading] = useState(false);

  const deleteNote = async (noteId, cvcapsula) => {
    setLoading(true);
    try {
      const response = await fetch(deleteNoteURL(noteId), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          cvcapsula: cvcapsula,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al eliminar la nota");
      }

      toastAlert("Nota eliminada correctamente", "success");
      return true;
    } catch (error) {
      console.error("Error al eliminar la nota:", error);
      toastAlert("Error al eliminar la nota: " + error.message, "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteNote, loading };
};
